import type { LocationCityId } from '@/collections/Locations/cityOptions'
import type { Locale } from '@/lib/i18n/config'
import { localizePath } from '@/lib/i18n/config'

export function getApartmentPath(
  citySlug: LocationCityId,
  locationSlug: string,
  apartmentSlug: string,
): string {
  return `/cities/${citySlug}/${locationSlug}/apartments/${apartmentSlug}`
}

export function getApartmentHref(
  citySlug: LocationCityId,
  locationSlug: string,
  apartmentSlug: string,
  locale: Locale,
): string {
  return localizePath(getApartmentPath(citySlug, locationSlug, apartmentSlug), locale)
}
